<template>
  <div class="new-policy-message">
    <h3>新增附言</h3>

    <!-- 附言输入表单 -->
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      style="margin-bottom: 20px"
    >
      <el-form-item prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="3"
          placeholder="请填写附言内容"
          clearable
        />
      </el-form-item>

      <!-- 文件上传 -->
      <el-form-item label="上传附件（图片/视频）">
        <upload-file
          ref="uploadbox"
          :disabled="false"
          :action="action"
          v-model="fileList"
          @delChange="delChange"
          :showImg="true"
        >
        </upload-file>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :loading="btnload" @click="submitComment"
          >提交附言</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 附言列表 -->
    <h3>附言列表</h3>
    <div class="emergency-record">
      <div
        class="record-item"
        v-for="(postscript, idx) in postscriptArray"
        :key="idx"
      >
        <div class="item-title">
          <p style="margin-right: 10px; width: 200px; color: #02a7f0">
            {{ postscript.name || "未知用户" }}
          </p>
          <p style="margin-right: 10px; width: 200px; color: #999">
            {{ postscript.role || "未知角色" }}
          </p>
        </div>
        <div class="item-content">
          <div class="reason">
            <span class="label-title" style="min-width: 70px">附言：</span>
            <p>{{ postscript.content || "无内容" }}</p>
          </div>
          <div class="file">
            <span class="label-title" style="min-width: 40px">附件：</span>
            <upload-file
              v-if="postscriptArray.length > 0"
              :disabled="true"
              action="/manage/car/feedback/question/upload/file?fileType=22"
              :file-list="postscript.files || []"
              :showImg="true"
            >
            </upload-file>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态：附言数组为空时显示 -->
    <p v-if="postscriptArray.length === 0" class="no-data">无附言</p>
  </div>
</template>

<script>
import { uploadUrl } from "@/util/url";
import { addPostscript, auditHistoryList } from "@/api/feedback.js";
import { resolvePostRole } from "@/utils/role";
import UploadFile from "@/components/uploadFileNew.vue";

export default {
  components: { UploadFile },
  props: {
    userName: {
      type: String,
      default: "匿名用户"
    },
    problemData: {
      default: () => {}
    },
    title: {
      default: ""
    },
    dataLS: {
      default: ""
    }
  },
  data() {
    return {
      btnload: false,
      action: "/manage/car/feedback/question/upload/file?fileType=22",
      form: {
        uploadUrl,
        content: ""
      },
      rules: {
        content: [
          { required: true, message: "请输入附言内容", trigger: "blur" },
          {
            min: 1,
            max: 500,
            message: "附言内容在 1 到 500 个字符之间",
            trigger: "blur"
          }
        ]
      },
      fileList: [], // el-upload 的文件列表（用于界面展示）
      postscriptArray: []
    };
  },
  computed: {
    currentTaskRoleName() {
      return (this.problemData && this.problemData.currentTaskRoleName) || "";
    },
    isCurrentTaskOwner() {
      const auditorId = this.problemData && this.problemData.currentTaskAuditorId;
      if (!auditorId) return false;
      const loginId = sessionStorage.getItem("staffAccountId");
      return !!loginId && String(loginId) === String(auditorId);
    }
  },
  mounted() {
    this.fetchCommentList();
  },
  methods: {
    // 删除文件
    delChange(file) {
      console.log("🚀 ~ delChange ~ file:", file);
      // this.form.delFileList.push(file.uploadFileId);
    },
    // 提交附言
    async submitComment() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;

        // 1. 处理文件列表（转为 {name, url} 格式）
        const uploadedFiles = this.fileList.map(file => ({
          name: file.fileName,
          url: file.filePath,
          type: file.fileType
        }));
        
        // 2. 构造附言数据（注意：只序列化一次，避免双重转义）
        const postscriptData = {
          carQualityFeedbackAuditId: this.$route.query.id || "",
          content: this.form.content,
          files: uploadedFiles,
          name: sessionStorage.getItem('name'),
          role: await resolvePostRole(this.currentTaskRoleName, { isOwner: this.isCurrentTaskOwner })
        };
        this.btnload = true;
        // 3. 提交附言（postscriptList 直接传对象的 JSON 字符串，不要二次序列化）
        await addPostscript({
          data: {
            questionId: this.problemData.questionId,
            postscriptType:
              this.title == "前置审批"
                ? 1
                : this.title == "应急措施"
                ? 2
                : this.title == "根因分析"
                ? 3
                : this.title == "永久方案"
                ? 4
                : "",
            postscriptList: JSON.stringify([
              ...[postscriptData],
              ...this.postscriptArray
            ])
          }
        });
        this.btnload = false;

        // 重置表单
        this.form.content = "";
        this.fileList = [];
        this.postscriptArray = [];
        this.$refs.uploadbox.clearfile();
        this.$refs.form.resetFields();
        this.$DonMessage.success("附言提交成功！");
        // 提交成功后，重新获取附言数组（自动刷新附言窗口）
        await this.fetchCommentList();
      });
    },
    getOperateResult(item) {
      let str = "";
      let auditResult = item.auditResult;
      // if(item.userTaskId == 'Activity_068dwsq'){
      //   str='已处理'
      // }else{
      auditResult == "0"
        ? (str = "已通过")
        : auditResult == 1
        ? (str = "审批驳回")
        : auditResult == 2
        ? (str = "审批通过")
        : auditResult == 3
        ? (str = "已知会")
        : (str = "");
      // }

      return str;
    },
    fixRawJson(raw) {
      // 1. 去掉最外层多余的双引号及转义
      const trimmed = raw.trim().replace(/^"(.*)"$/, "$1");

      // 2. 把所有 \" 还原成 "
      const unescaped = trimmed.replace(/\\"/g, '"');
      // 3. 按 “}{” 分割成多个独立 JSON 片段，再拼成数组
      const parts = unescaped
        .split(/(?<=})(?={)/) // 用零宽断言切分，不破坏花括号
        .map(s => s.trim())
        .filter(Boolean);

      // 4. 逐个解析并收集
      return parts.map(p => JSON.parse(p));
    },
    // 获取当前任务对应的角色名已改为通过 props 直接读取，无需独立请求
    async fetchCommentList() {
      try {
        const res = await auditHistoryList({
          data: {
            questionId: this.problemData.questionId
          }
        });
        this.privateList = res.data || []; // 审核历史列表（确保是数组）
        let titleNum =
          this.title == "前置审批"
            ? 1
            : this.title == "应急措施"
            ? 2
            : this.title == "根因分析"
            ? 3
            : this.title == "永久方案"
            ? 4
            : "";
        this.privateList = this.privateList.filter(
          item => item.postscriptType == titleNum
        );

        if (this.privateList.length > 0) {
          const rawPostscriptStr = this.privateList[0].postscriptList || "";
          // this.postscriptArray = this.fixRawJson(rawPostscriptStr);
        
          this.postscriptArray = JSON.parse(rawPostscriptStr) || [];
          console.log(this.postscriptArray);
          if (!Array.isArray(this.postscriptArray)) {
            this.postscriptArray = [this.postscriptArray];
          }
          for (let d = 0; d < this.postscriptArray.length; d++) {
            let itemd = this.postscriptArray[d];
            for (let a = 0; a < itemd.files.length; a++) {
              let item = itemd.files[a];
              item.filePath = item.url;
              item.fileName = item.name;
              item.fileType = item.type;
            }
          }
        } else {
          this.privateList = [];
          this.postscriptArray = []; // 无审核记录时，附言数组为空
        }
      } catch (error) {
        console.error("获取/解析附言失败：", error);
        this.privateList = [];
        this.postscriptArray = [];
        // this.$DonMessage.error("获取附言列表失败");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.emergency-content {
  // width: 100%;
  padding: 14px 10px 14px 20px;
  box-sizing: border-box;
  .record-title {
    background-color: rgb(195, 234, 252);
    font-size: 14px;
    color: #333;
    padding: 10px 18px;
    border: 1px solid #dcd9d9;
    margin-bottom: 14px;
  }
  .emergency-record {
    border: 1px solid #dcd9d9;
    font-size: 14px;
    .item-title {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dcd9d9;
      background-color: rgb(242, 242, 242);
      padding: 10px 18px;
      p {
        font-size: 14px;
      }
    }
    .item-content {
      padding: 18px 18px;
      border-bottom: 1px solid #dcd9d9;
      display: flex;
      align-items: baseline;
      font-size: 14px;
      .reason {
        display: flex;
        margin-right: 20px;
        p {
          padding: 8px;
          background-color: rgb(242, 242, 242);
          border: 1px solid rgb(215, 215, 215);
          border-radius: 2px;
          min-width: 100px;
          max-width: 300px;
          white-space: pre-wrap;
          word-wrap: break-word;
        }
      }
      .file {
        display: flex;
      }
      .private {
        margin-left: 12px;
        display: flex;
      }
    }
  }
  .label-title {
    display: block;
    flex-shrink: 0;
  }
}
.new-policy-message {
  // width: 100%;
  // max-width: 900px;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  h3 {
    margin-bottom: 15px;
    color: #333;
    font-weight: 500;
  }

  .comment-item {
    p {
      margin: 8px 0;
      line-height: 1.5;
      color: #555;
    }
    .time {
      color: #999;
      margin-top: 10px;
    }
  }

  .media-preview {
    margin: 10px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .no-data {
    text-align: center;
    color: #999;
    // font-style: italic;
    margin: 10px 0;
  }
}
</style>
